module.exports = __webpack_public_path__ + "static/media/ins-migracja.6849ac5f.jpg";